module.exports = __webpack_public_path__ + "static/tracer-building-07ed2078e8daaf26fbfd884c749716df.webm";